module.exports = __webpack_public_path__ + "img/cry-offline.7e6d74bf.gif";